import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import {POST_BLACKLISTED_CANDIDATE_SEARCH_URL} from '../../constants/apiUrls';
import {PaginatedData} from '../../models/List';
import {ApiPathParam} from '../../models/SearchParamSchema';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface BlacklistedCandidateSearchResponse {
  uuid: string;
  name: string;
  candidateId: string;
  dateOfBirth: string;
  examType: string;
  creationDate: string;
  creatorName: string;
}

export interface BlacklistedCandidateSearchRequest {
  searchParam?: string;
  examType?: string;
  pathParams: ApiPathParam;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<BlacklistedCandidateSearchResponse>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostBlacklistedCandidateSearch = ({onSuccess, onError}: Input = {}) => {
  const postBlacklistedCandidateSearch = async (reqBody: BlacklistedCandidateSearchRequest) => {
    const res = await axiosClient.post<PaginatedData<BlacklistedCandidateSearchResponse>>(
        POST_BLACKLISTED_CANDIDATE_SEARCH_URL(reqBody.pathParams),
        {
          q: reqBody.searchParam,
          examType: reqBody.examType,
        }
    );
    return res.data;
  };

  return useCustomMutation(postBlacklistedCandidateSearch, {
    onSuccess,
    onError,
  });
};
